var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15152 10.1773C5.15152 9.63679 5.2413 9.11858 5.40152 8.63253L2.59698 6.49088C2.05039 7.60066 1.74243 8.85116 1.74243 10.1773C1.74243 11.5023 2.05001 12.7521 2.59584 13.8611L5.39887 11.7153C5.24016 11.2315 5.15152 10.7152 5.15152 10.1773",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0757 5.26006C11.25 5.26006 12.3106 5.67614 13.1439 6.35699L15.5681 3.93618C14.0909 2.65013 12.1969 1.8558 10.0757 1.8558C6.78253 1.8558 3.95223 3.73911 2.59692 6.49089L5.40147 8.63254C6.04768 6.67093 7.88973 5.26006 10.0757 5.26006",
    fill: "#EB4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0757 15.0946C7.88973 15.0946 6.04768 13.6837 5.40147 11.7221L2.59692 13.8634C3.95223 16.6155 6.78253 18.4988 10.0757 18.4988C12.1083 18.4988 14.0488 17.7771 15.5053 16.4249L12.8431 14.3668C12.092 14.84 11.1462 15.0946 10.0757 15.0946",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0304 10.1773C18.0304 9.68558 17.9546 9.15603 17.841 8.66431H10.0758V11.8794H14.5455C14.322 12.9756 13.7137 13.8183 12.8432 14.3668L15.5054 16.4249C17.0353 15.0049 18.0304 12.8897 18.0304 10.1773",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.89e04127fda058070580abf715baf98e.svg";
export { ForwardRef as ReactComponent };